import { extendTheme as chakraExtendTheme, theme, } from "@chakra-ui/react";
import { generateColorPalette } from "./utils";
import { Color } from "./constants";
const defaultTheme = {
    config: {
        useSystemColorMode: false,
        initialColorMode: "light",
    },
    // Weird export error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    layerStyles: {},
    colors: {
        primary: generateColorPalette("#ff7f50"),
        secondary: generateColorPalette(Color.pbr.main),
        info: generateColorPalette(Color.sea.main),
        success: generateColorPalette(Color.apple.main),
        warning: generateColorPalette(Color.sun.main),
        error: generateColorPalette(Color.cherry.main),
        gray: theme.colors.gray,
    },
    fonts: {
        body: "Roboto, sans-serif",
        heading: "Roboto, sans-serif",
        mono: "Roboto, sans-serif",
    },
    radii: {
        none: "0",
        sm: "0",
        md: "0",
        lg: "0",
        full: "9999px",
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: "0.35rem",
            },
            sizes: {
                xl: {
                    height: 16,
                    minWidth: 16,
                    fontSize: "xl",
                    px: 12,
                },
                lg: {
                    height: 12,
                    minWidth: 12,
                    fontSize: "lg",
                    px: 8,
                },
                md: {
                    height: 10,
                    minWidth: 10,
                    fontSize: "md",
                    px: 6,
                },
                sm: {
                    height: 8,
                    minWidth: 8,
                    fontSize: "sm",
                    px: 4,
                },
                xs: {
                    height: 6,
                    minWidth: 6,
                    fontSize: "xs",
                    px: 2,
                },
            },
        },
        CompassLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        ClientLoader: {
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        FormLabel: {
            baseStyle: {
                fontWeight: 500,
            },
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        bg: "white",
                    },
                },
            },
        },
        NoomLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Popover: {
            variants: {
                responsive: {
                    popper: {
                        maxWidth: "unset",
                        width: "unset",
                    },
                },
            },
        },
        Tag: {
            sizes: {
                sm: { container: { borderRadius: "0.3rem" } },
                md: { container: { borderRadius: "0.35rem" } },
                lg: { container: { borderRadius: "0.35rem" } },
            },
        },
        Tooltip: {
            baseStyle: {
                color: "white",
            },
        },
        Heading: {
            baseStyle: {
                fontWeight: 300,
            },
        },
    },
};
export function extendTheme(customTheme) {
    return chakraExtendTheme(theme, defaultTheme, customTheme);
}
export default chakraExtendTheme(theme, defaultTheme);
//# sourceMappingURL=defaultTheme.js.map